import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Lock } from 'lucide-react';
import { Board } from '../types';
interface BoardSelectorProps {
  boards: Board[];
  isOpen: boolean;
  onSelect: (boardId: string) => void;
  onClose: () => void;
  onCreateBoard: (name: string) => void;
}
export function BoardSelector({
  boards,
  isOpen,
  onSelect,
  onClose,
  onCreateBoard
}: BoardSelectorProps) {
  if (!isOpen) return null;
  return <AnimatePresence data-id="element-1">
      <motion.div initial={{
      opacity: 0,
      y: 10,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 10,
      scale: 0.95
    }} className="absolute right-0 top-full mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden z-50" onClick={e => e.stopPropagation()} data-id="element-2">
        <div className="p-3 border-b border-gray-100" data-id="element-3">
          <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 px-2" data-id="element-4">
            Save to board
          </h3>
          <div className="space-y-1 max-h-48 overflow-y-auto" data-id="element-5">
            {boards.map(board => <button key={board.id} onClick={() => onSelect(board.id)} className="w-full flex items-center gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors text-left group" data-id="element-6">
                <div className="w-8 h-8 rounded-md bg-gray-200 overflow-hidden flex-shrink-0" data-id="element-7">
                  {board.coverImage && <img src={board.coverImage} alt="" className="w-full h-full object-cover" data-id="element-8" />}
                </div>
                <div className="flex-1 min-w-0" data-id="element-9">
                  <p className="text-sm font-medium text-gray-900 truncate group-hover:text-black" data-id="element-10">
                    {board.name}
                  </p>
                  {board.isPrivate && <Lock className="w-3 h-3 text-gray-400" data-id="element-11" />}
                </div>
              </button>)}
          </div>
        </div>
        <button onClick={() => onCreateBoard('New Board')} className="w-full flex items-center gap-2 p-3 text-sm font-semibold text-gray-600 hover:bg-gray-50 hover:text-black transition-colors" data-id="element-12">
          <div className="w-8 h-8 rounded-md bg-gray-100 flex items-center justify-center" data-id="element-13">
            <Plus className="w-4 h-4" data-id="element-14" />
          </div>
          Create Board
        </button>
      </motion.div>
    </AnimatePresence>;
}